import { Middleware } from 'redux'
import { LOCATION_CHANGE } from 'connected-react-router'
import { APP_ROOT_ID } from '../../../constants/appConstants'

const scrollTopMiddleware = (window: Window): Middleware => () => (next) => (action) => {
    next(action)

    if (action.type === LOCATION_CHANGE) {
        if (!action.payload?.location?.hash) {
            const root = document.getElementById(APP_ROOT_ID)
            if (root) {
                root.scrollTo(0, 0)
            } else {
                window.scrollTo(0, 0)
            }
        }
    }
}

export default scrollTopMiddleware
